// 'use client'

// import React from 'react';
// import Slider from 'react-slick';
// import ArrowSvg from '../individual-components/arrow-svg';
// import NextImage from '../NextImage';
// import { clientLogos } from '@/assets/data/constants';

// const Clients = ({ noSpacing = false }) => {
//     const settings = {
//         dots: false,
//         infinite: true,
//         speed: 500,
//         slidesToShow: 5, // Number of visible slides
//         slidesToScroll: 1,
//         autoplay: true,
//         autoplaySpeed: 3000,
//         responsive: [
//             {
//                 breakpoint: 1024,
//                 settings: {
//                     slidesToShow: 3,
//                 },
//             },
//             {
//                 breakpoint: 600,
//                 settings: {
//                     slidesToShow: 2,
//                 },
//             },
//             {
//                 breakpoint: 480,
//                 settings: {
//                     slidesToShow: 1,
//                 },
//             },
//         ],
//     };

//     const SliderComponent = () => (
//         <Slider
//             {...settings}
//             lazyLoad='ondemand'
//             // prevArrow={<ArrowSvg direction='prev' />}
//             // nextArrow={<ArrowSvg direction='next' />}
//         >
//             {clientLogos?.map((logo, index) => (
//                 <div key={logo} className="client-logo">
//                     <NextImage
//                         height={'40px'}
//                         width={'auto'} // Or adjust width as needed
//                         src={logo}
//                         alt={`Client ${index + 1}`}
//                         className="mx-3"
//                     />
//                 </div>
//             ))}
//         </Slider>
//     )

//     if (noSpacing) {
//         return <SliderComponent />
//     }

//     return (
//         <section className='px-4'>
//             <div className="max-w-7xl md:mx-4 px-4 mx-auto">
//                 <div className='py-14 pt-0 sm:py-0 sm:mt-2 px-5 mb-10 mt-16'>
//                     <SliderComponent />
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default Clients;


'use client'

import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper';
import NextImage from '../NextImage';
import { clientLogos } from '@/assets/data/constants';

const ClientSwiper = () => (
    <Swiper
        modules={[Navigation, Autoplay]}
        slidesPerView={5}
        autoplay={{
            delay: 3000,
            disableOnInteraction: false,
        }}
        loop
    >
        {clientLogos?.map((logo, index) => (
            <SwiperSlide key={logo} className="client-logo">
                <NextImage
                    height={'40px'}
                    width={'auto'} // Or adjust width as needed
                    src={logo}
                    alt={`Client ${index + 1}`}
                    className="mx-3 sm:mx-1"
                />
            </SwiperSlide>
        ))}
    </Swiper>
)

const Clients = ({ noSpacing = false }) => {


    if (noSpacing) {
        return <ClientSwiper />
    }

    return (
        <section className={'px-4'}>
            <div className="max-w-7xl md:mx-4 px-4 mx-auto">
                <div className={'py-14 pt-0 sm:py-0 sm:mt-2 mb-10 mt-16'}>
                    <ClientSwiper />
                </div>
            </div>
        </section>
    );
};

export default Clients;
